import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {reportingPlatforms} from '../data/socialReportingGuide';
import './SocialReportingGuide.css';

const {FiExternalLink, FiInfo} = FiIcons;

function SocialReportingGuide() {
  return (
    <section className="reporting-guide" aria-labelledby="reporting-guide-title">
      <div className="reporting-guide-heading">
        <span className="eyebrow">
          <SafeIcon icon={FiInfo} />
          Platform help
        </span>
        <h2 id="reporting-guide-title">How to report a post on social media</h2>
        <p>
          Follow the steps for the platform. Menu names and reporting options
          can vary by app version and region.
        </p>
      </div>

      <div className="reporting-platform-list">
        {reportingPlatforms.map((platform, index) => (
          <details className="reporting-platform" key={platform.name} open={index === 0}>
            <summary>
              <span className="reporting-number">{String(index + 1).padStart(2, '0')}</span>
              <span className="reporting-platform-name">{platform.name}</span>
              <span className="reporting-summary-hint">View steps</span>
            </summary>

            <div className="reporting-platform-content">
              <ol>
                {platform.steps.map((step) => (
                  <li key={step}>{step}</li>
                ))}
              </ol>

              {platform.notes.map((note) => (
                <p className="reporting-note" key={note}>{note}</p>
              ))}

              <a
                className="reporting-source"
                href={platform.source.url}
                target="_blank"
                rel="noreferrer"
              >
                <SafeIcon icon={FiExternalLink} />
                <span>Official source: {platform.source.label}</span>
              </a>
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}

export default SocialReportingGuide;